var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgAddVideo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 17,
    height: 16,
    viewBox: "0 0 17 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.16667 6V8M7.16667 10V8M7.16667 8H9.16667M7.16667 8H5.16667M11.8333 8V5.33333C11.8333 4.97971 11.6929 4.64057 11.4428 4.39052C11.1928 4.14048 10.8536 4 10.5 4H3.83333C3.47971 4 3.14057 4.14048 2.89052 4.39052C2.64048 4.64057 2.5 4.97971 2.5 5.33333V10.6667C2.5 11.0203 2.64048 11.3594 2.89052 11.6095C3.14057 11.8595 3.47971 12 3.83333 12H10.5C10.8536 12 11.1928 11.8595 11.4428 11.6095C11.6929 11.3594 11.8333 11.0203 11.8333 10.6667V8ZM11.8333 8L14.5 5.33333V10.6667L11.8333 8Z",
    stroke: "white",
    strokeWidth: 1.33333,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAddVideo);
export default __webpack_public_path__ + "static/media/add-video.918ee725ddd74a9cd38cd456628544c8.svg";
export { ForwardRef as ReactComponent };